"use client"

import { useEffect, useState } from "react"
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const ThemedToaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props}
    />
  )
}

const Toaster = (props: ToasterProps) => <ThemedToaster {...props} />

interface ResponsiveToasterProps extends ToasterProps {
  mobilePosition?: ToasterProps["position"]
  desktopPosition?: ToasterProps["position"]
  breakpoint?: number
}

const ResponsiveToaster = ({
  mobilePosition = "top-center",
  desktopPosition = "bottom-right",
  breakpoint = 768,
  ...props
}: ResponsiveToasterProps) => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < breakpoint)

    handleResize()
    window.addEventListener("resize", handleResize)

    return () => window.removeEventListener("resize", handleResize)
  }, [breakpoint])

  return (
    <ThemedToaster
      {...props}
      position={isMobile ? mobilePosition : desktopPosition}
    />
  )
}

export { Toaster, ResponsiveToaster }
